import { ErrorBoundary } from "@temp/components/ErrorBoundary";
import React from "react";
import ProductListItem from "./ProductListItem";

var ProductList = function ProductList(_ref) {
  var lines = _ref.lines,
      remove = _ref.remove,
      readonly = _ref.readonly;
  return React.createElement("ul", {
    className: "cart__list"
  }, lines.map(function (line) {
    var key = "".concat(line.variant.id).concat(line.productAttributes.map(function (attr) {
      return attr.attributeId;
    }).join());
    return React.createElement(ErrorBoundary, {
      key: key
    }, React.createElement(ProductListItem, {
      line: line,
      remove: remove,
      readonly: readonly
    }));
  }));
};

export default ProductList;